import React, {useEffect, useState} from "react";
import {getEventRegistrationFields} from "../EventAccessPreModeration/tools";
import {useEventContext} from "../../../context";
import {Button, Checkbox, ControlLabel, FormControl, FormGroup, Table} from "react-bootstrap";
import Select from "react-select";
import {
    clientImportExecute,
    clientImportTimePadEventFetch,
    clientImportTimePadSettingsUpdate
} from "../../../../api/cp";


export default ({settings, onClose}) => {
    const {event} = useEventContext();
    const [fieldsMapper, setFieldsMapper] = useState(settings.fieldsMapper || {});
    const [useHook, setUseHook] = useState(settings.useHook);
    const [sendMail, setSendMail] = useState(settings.sendMail);
    const [timePadFields, setTimePadFields] = useState(null);
    const [disables, setDisabled] = useState(false);

    const {accessToken, settings: {timePadEvent}} = settings;
    const eventRegistrationFields = [
        {
            name: 'email',
            label: 'Email',
        },
        ...getEventRegistrationFields(event),
    ];

    const handleChangeFieldMapper = async (name, value) => {
        const data = {...fieldsMapper, [name]: value};
        setFieldsMapper(data);
        setDisabled(true);
        try {
            await clientImportTimePadSettingsUpdate(event.eventKey, settings.id, {fieldsMapper: data});
        } catch (e) {
            console.log(e);
        }
        setDisabled(false);
    }

    const handleChangeUseHook = async (useHook) => {
        setUseHook(useHook);
        setDisabled(true);
        try {
            await clientImportTimePadSettingsUpdate(event.eventKey, settings.id, {useHook});
        } catch (e) {
            console.error(e);
        }
        setDisabled(false);
    }

    const handleChangeSendMail = async (sendMail) => {
        setSendMail(sendMail);
        setDisabled(true);
        try {
            await clientImportTimePadSettingsUpdate(event.eventKey, settings.id, {sendMail});
        } catch (e) {
            console.error(e);
        }
        setDisabled(false);
    }

    const handleImport = async () => {
        const warningText = 'Включена отправка письма о регистрации. При импорте сразу будут отправляться письма о регистрации.';
        if (sendMail && !confirm(warningText)) {
            return;
        }

        setDisabled(true);
        try {
            await clientImportExecute(event.eventKey, settings.id);
            alert('Данные будут импортированы в ближайшее время');
        } catch (e) {
            console.error(e);
        }
        setDisabled(false);
    }

    useEffect(async () => {
        const {fields} = await clientImportTimePadEventFetch(event.eventKey, accessToken, timePadEvent.id);
        setTimePadFields(fields);
    }, []);

    if (null === timePadFields) {
        return (
            <p>Загрузка списка полей регистрации</p>
        );
    }

    const timePadFieldsOptions = timePadFields.map(({name, label}) => ({value: name, label}));

    return (
        <>
            <FormGroup>
                <ControlLabel>Событие TimePad</ControlLabel>
                <FormControl
                    type="text"
                    value={timePadEvent.name}
                    readOnly
                />
            </FormGroup>
            <FormGroup>
                <Table>
                    <thead>
                    <tr>
                        <th>Поле регистрации COMDI</th>
                        <th>Поле регистрации TimePad</th>
                    </tr>
                    </thead>
                    <tbody>
                    {eventRegistrationFields.map(({name, label}) => (
                        <tr key={name}>
                            <td>{label}</td>
                            <td>
                                <Select
                                    options={timePadFieldsOptions}
                                    value={timePadFieldsOptions.find(({value}) => value === fieldsMapper[name])}
                                    onChange={({value}) => handleChangeFieldMapper(name, value)}
                                    isDisabled={disables}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </FormGroup>
            <FormGroup>
                <Checkbox
                    checked={useHook}
                    onChange={(e) => handleChangeUseHook(e.target.checked)}
                    disabled={disables}
                >Использовать TimePad Hook</Checkbox>
            </FormGroup>
            <FormGroup>
                <Checkbox
                    checked={sendMail}
                    onChange={(e) => handleChangeSendMail(e.target.checked)}
                    disabled={disables}
                >Отправлять письмо о регистрации при импорте</Checkbox>
            </FormGroup>
            <FormGroup>
                <Button onClick={handleImport} bsStyle="primary" disabled={disables}>Импортировать сейчас</Button>
                {' '}
                <Button onClick={onClose}>Закрыть</Button>
            </FormGroup>
        </>
    );
}
